/* Volti Games — carrito: Ajax Cart API (/cart/add.js, /cart/change.js, /cart/update.js) + Section Rendering.
   Shopify calcula precios, descuentos automáticos ("Lleva más, paga menos") y el total. */
(() => {
  const { d, C, R, reduce, $, $$, esc, parse, plural, showToast } = window.VG;
  const cartA = $('#cart'), cartN = $('#cartN');
  const bump = () => { if (!cartN) return; cartN.classList.remove('bump'); void cartN.offsetWidth; cartN.classList.add('bump'); };
  const fly = (from, done) => {
    if (reduce || !from || !cartA || !from.getBoundingClientRect || !from.animate) return done();
    const a = from.getBoundingClientRect(), c = cartA.getBoundingClientRect();
    const el = d.createElement('div'); el.className = 'fly'; d.body.appendChild(el);
    const x0 = a.left + a.width / 2 - 11, y0 = a.top + a.height / 2 - 11, x1 = c.left + c.width / 2 - 11, y1 = c.top + c.height / 2 - 11;
    el.animate([
      { transform: `translate(${x0}px,${y0}px) scale(1)` },
      { transform: `translate(${(x0 + x1) / 2}px,${Math.min(y0, y1) - 120}px) scale(1.3)`, offset: .5 },
      { transform: `translate(${x1}px,${y1}px) scale(.4)`, opacity: .6 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.6,1)' }).onfinish = () => { el.remove(); done(); };
  };

  const DRW = 'vg-cart-drawer', drw = $('#drw');
  const onCartPage = C.template === 'cart';
  const state = { count: +(drw ? drw.dataset.count : (cartN ? cartN.textContent : 0)) || 0, games: +(drw ? drw.dataset.games : 0) || 0 };
  const sync = () => {
    if (cartN) cartN.textContent = state.count;
    if (cartA) cartA.setAttribute('aria-label', `Carrito, ${state.count} ${plural(state.count, 'producto', 'productos')}`);
    d.dispatchEvent(new CustomEvent('vg:cart', { detail: state }));
  };
  const pageSections = () => $$('[data-cart-section]').map(e => e.dataset.cartSection);
  const applySections = s => {
    if (!s) return;
    if (s[DRW] && drw) {
      const n = $('#drw', parse(s[DRW]));
      if (n) {
        ['#drwN', '#drwBody', '#drwFt'].forEach(k => { const a = $(k, drw), b = $(k, n); if (a && b) { a.innerHTML = b.innerHTML; a.hidden = b.hidden; } });
        state.count = +n.dataset.count || 0; state.games = +n.dataset.games || 0;
        drw.dataset.count = state.count; drw.dataset.games = state.games;
      }
    }
    pageSections().forEach(id => {
      if (!s[id]) return;
      const n = $(`[data-cart-section="${id}"]`, parse(s[id])), o = $(`[data-cart-section="${id}"]`);
      if (n && o) { o.replaceWith(n); $$('.rv', n).forEach(x => x.classList.add('in')); }
    });
    sync();
  };
  const post = async (url, body) => {
    const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const j = await r.json(); if (!r.ok || j.status) throw j; return j;
  };
  const extra = () => ({ sections: [DRW, ...pageSections()].join(','), sections_url: location.pathname });
  const cartAdd = async (id, quantity = 1) => { const j = await post(R.cart_add + '.js', { items: [{ id: +id, quantity }], ...extra() }); applySections(j.sections); return j; };
  const cartChange = async (key, quantity) => { const j = await post(R.cart_change + '.js', { id: key, quantity, ...extra() }); applySections(j.sections); return j; };
  const cartUpdate = async body => { const j = await post(R.cart_update + '.js', { ...body, ...extra() }); applySections(j.sections); return j; };
  const errMsg = e => (e && (e.description || e.message)) || 'Inténtalo de nuevo.';
  const errToast = er => showToast(`<div><b>No pudimos actualizar el carrito</b><small>${esc(errMsg(er))}</small></div>`);

  /* Carrito lateral: se abre al agregar o al tocar el ícono; Escape y tocar afuera lo cierran; el foco queda adentro */
  let lastFocus = null;
  const openCart = () => {
    if (!drw) { location.href = R.cart; return; }
    if (drw.classList.contains('is-open')) return;
    lastFocus = d.activeElement;
    d.documentElement.classList.add('drw-open');
    drw.classList.add('is-open', 'is-intro');
    setTimeout(() => drw.classList.remove('is-intro'), 900);
    setTimeout(() => { const x = $('.drw__x', drw); if (x) x.focus({ preventScroll: true }); }, 60);
  };
  const closeCart = () => {
    if (!drw || !drw.classList.contains('is-open')) return;
    drw.classList.remove('is-open'); d.documentElement.classList.remove('drw-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  const lineAction = (b, li, act) => {
    const key = li.dataset.key, q = +li.dataset.qty; b.disabled = true;
    const run = () => cartChange(key, act === 'inc' ? q + 1 : act === 'dec' ? q - 1 : 0).catch(er => { b.disabled = false; li.classList.remove('is-out'); errToast(er); });
    if (act === 'del' || (act === 'dec' && q <= 1)) { li.classList.add('is-out'); setTimeout(run, reduce ? 0 : 260); } else run();
  };
  if (drw) {
    drw.addEventListener('click', e => {
      if (e.target.closest('[data-dclose]')) { closeCart(); return; }
      const b = e.target.closest('[data-dact]'); if (!b) return;
      lineAction(b, b.closest('.dl'), b.dataset.dact);
    });
    drw.addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeCart(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('a[href],button:not([disabled]),input', $('.drw__p', drw)).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
  }
  if (cartA && !onCartPage && drw) cartA.addEventListener('click', e => { e.preventDefault(); openCart(); });

  /* Agregar: el punto lima vuela al ícono, el contador rebota y se abre el carrito lateral */
  const add = async (id, { qty = 1, from, silent, name } = {}) => {
    try {
      await Promise.all([cartAdd(id, qty), new Promise(r => fly(from, r))]);
      bump();
      if (onCartPage) showToast(`<div><b>${esc(name || 'Producto')}</b><small>Agregado al carrito</small></div>`);
      else if (!silent) openCart();
      return true;
    } catch (er) {
      showToast(`<div><b>No pudimos agregarlo</b><small>${esc(errMsg(er))}</small></div>`);
      return false;
    }
  };
  d.addEventListener('click', e => {
    const b = e.target.closest('[data-buy]'); if (!b || b.disabled) return;
    e.preventDefault();
    b.classList.add('ok'); setTimeout(() => b.classList.remove('ok'), 1600);
    add(b.dataset.buy, { from: b, name: b.dataset.name });
  });

  /* Página del carrito: cantidades, eliminar y cupón */
  d.addEventListener('click', e => {
    const b = e.target.closest('[data-act]'); if (!b) return;
    const li = b.closest('.line'); if (li) lineAction(b, li, b.dataset.act);
  });
  const codes = () => { const el = $('[data-codes]'); return el && el.dataset.codes ? el.dataset.codes.split(',').filter(Boolean) : []; };
  d.addEventListener('click', async e => {
    const b = e.target.closest('#cuponBtn'); if (!b) return;
    const inp = $('#cupon'), v = inp ? inp.value.trim() : '';
    const say = (t, bad) => { const m = $('#cuponMsg'); if (m) { m.textContent = t; m.className = bad ? 'bad' : ''; } };
    if (!v) { say('Escribe un código.', true); return; }
    b.disabled = true;
    try {
      const j = await cartUpdate({ discount: [...new Set([...codes(), v])].join(',') });
      const ok = (j.discount_codes || []).find(c => c.code.toLowerCase() === v.toLowerCase());
      say(ok && ok.applicable ? `Cupón ${ok.code} aplicado.` : 'El código no es válido o no aplica a este carrito. Recuerda que los cupones no se combinan con el 4x3.', !(ok && ok.applicable));
    } catch (er) { say('No pudimos aplicar el cupón. También puedes ingresarlo al pagar.', true); }
    finally { const nb = $('#cuponBtn'); if (nb) nb.disabled = false; }
  });
  d.addEventListener('click', async e => {
    const b = e.target.closest('[data-rmcode]'); if (!b) return;
    try { await cartUpdate({ discount: codes().filter(c => c !== b.dataset.rmcode).join(',') }); } catch (er) { errToast(er); }
  });
  d.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target.id === 'cupon') { e.preventDefault(); const b = $('#cuponBtn'); if (b) b.click(); } });

  sync();
  Object.assign(window.VG, { add, openCart, closeCart, cartAdd, cartChange, cartUpdate, errMsg, state });
})();